var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31248",
    "data-name": "Group 31248",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.257,
    height: 13.333,
    viewBox: "0 0 89.257 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16061",
    "data-name": "Path 16061",
    d: "M217.281,1866.778H303.2",
    transform: "translate(-217.281 -1860.111)",
    fill: "none",
    stroke: "#09161a",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16062",
    "data-name": "Path 16062",
    d: "M398.333,1824.333,405,1831l-6.667,6.667",
    transform: "translate(-315.743 -1824.333)",
    fill: "#09161a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.d7e6a2e037d2a1def31d6607a2221022.svg";
export { ForwardRef as ReactComponent };